const blankResourceDayType = {
  date:'',
  dayType: null,
  allDayTypes: true,
  comment: '',
  myComment: '',
  tkComment: '',
};

export default blankResourceDayType;
